// extracted by mini-css-extract-plugin
module.exports = {"box":"box--36AhU","bannerWrap":"bannerWrap--3I7Xw","all":"all--3fFVi","gradient":"gradient--1x2Vc","banner":"banner--2YpKn"};